import { c as _c } from "react/compiler-runtime";
import type { Participant } from '@svenskaspelab/poolbetting/schema/sport';
import { CouponEventOutcomesPrediction, CouponEventParticipants, CouponOutcomePrediction } from '@svenskaspelab/poolbetting/ui/Coupon';
import type { ReactNode } from 'react';
type CouponOverviewRowProps = {
  eventParticipants?: (Participant | undefined)[];
  eventNumber: number;
  eventDescription: string;
  selectedOutcomes: number[];
  outcomeCount: number;
};

/**
 * CouponOverview component.
 *
 * @param root0 - The props object.
 * @param root0.eventParticipants - The participants of the current draw
 * @param root0.eventNumber - The number of the current event
 * @param root0.eventDescription - The description of the current event
 * @param root0.selectedOutcomes - The selected outcomes of the current event
 * @param root0.outcomeCount - The number of outcomes for the current event
 * @returns A coupon row of the coupon overview component.
 */
export default function CouponOverviewRow(t0) {
  const $ = _c(17);
  const {
    eventParticipants,
    eventNumber,
    eventDescription,
    selectedOutcomes,
    outcomeCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["grid", "grid-cols-3", "[grid-template-areas:'eventNumber_eventParticipants_betButtons']", "grid-cols-[max-content_auto_max-content]", "text-sm", "pt-1.5", "pb-1.5", "border-b", "border-stroke-low", "last:border-0", "pl-2", "pr-2", "lg:pl-0", "lg:pr-0", "even:bg-grey-warm-80", "gap-2"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const classNames = t1;
  let t2;
  if ($[1] !== eventNumber) {
    t2 = <div className="text-layer-fg-muted">{eventNumber}</div>;
    $[1] = eventNumber;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== eventDescription || $[4] !== eventParticipants) {
    t3 = <div className="min-w-0"><CouponEventParticipants className="text-layer-fg flex min-w-0 gap-1" participants={eventParticipants} eventDescription={eventDescription} participantClassName="min-w-0 text-sm font-normal">-</CouponEventParticipants></div>;
    $[3] = eventDescription;
    $[4] = eventParticipants;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== eventNumber) {
    t4 = props => <CouponOutcomePrediction {...props} buttonClassName="border-0 grid place-items-center inline-flex" key={props.index} buttonSize="sm" eventNumber={eventNumber} />;
    $[6] = eventNumber;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== outcomeCount || $[9] !== selectedOutcomes || $[10] !== t4) {
    t5 = <CouponEventOutcomesPrediction className="sm:gap-x-1.5" selectedOutcomes={selectedOutcomes} outcomeCount={outcomeCount} renderItem={t4} />;
    $[8] = outcomeCount;
    $[9] = selectedOutcomes;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== eventNumber || $[13] !== t2 || $[14] !== t3 || $[15] !== t5) {
    t6 = <div key={eventNumber} className={classNames.join(" ")}>{t2}{t3}{t5}</div>;
    $[12] = eventNumber;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}